export * from './footer';
export * from './header';
export * from './modal';
export * from './privacy';
